export default "/imgs/falsification_scheme_mob.png"